/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Legalguardiancontactmethods3Inputs */

const de__field_legalguardiancontactmethods3 = /** @type {(inputs: _Field_Legalguardiancontactmethods3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugte Kontaktmethode der Erziehungsberechtigten`)
};

/**

* @param {_Field_Legalguardiancontactmethods3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_legalguardiancontactmethods3 = /** @type {((inputs?: _Field_Legalguardiancontactmethods3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Legalguardiancontactmethods3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_legalguardiancontactmethods3(inputs)
});
export { _field_legalguardiancontactmethods3 as "_field_legalGuardianContactMethods" }